import { domainEvent, DomainEvent, MessageName } from "@lookiero/messaging";

const CHECKOUT_BOOKING_NOT_EXPIRED = "checkout_booking_not_expired";

interface CheckoutBookingNotExpiredPayload {
  readonly aggregateId: string;
}

interface CheckoutBookingNotExpired
  extends DomainEvent<typeof CHECKOUT_BOOKING_NOT_EXPIRED>, CheckoutBookingNotExpiredPayload {}

interface CheckoutBookingNotExpiredFunction {
  (payload: CheckoutBookingNotExpiredPayload): CheckoutBookingNotExpired;
}

const checkoutBookingNotExpired: CheckoutBookingNotExpiredFunction = ({ aggregateId }) =>
  domainEvent({ aggregateId, name: CHECKOUT_BOOKING_NOT_EXPIRED });

const isCheckoutBookingNotExpired = (event: DomainEvent<MessageName>): event is CheckoutBookingNotExpired =>
  event.name === CHECKOUT_BOOKING_NOT_EXPIRED;

export type { CheckoutBookingNotExpired };
export { CHECKOUT_BOOKING_NOT_EXPIRED, checkoutBookingNotExpired, isCheckoutBookingNotExpired };
